import * as React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Text } from '@wix/design-system';
import { RootStore, withInjectedRootStore } from 'providers';
import { SaleBannerSubtitle } from './SaleBannerSubtitle';
import s from './SaleBanner.scss';
import { useSaleBannerTitle } from './useSaleBannerTitle';
import { usePageModeContext } from 'providers/PageMode/PageMode.provider';
import classNames from 'classnames';
import { Experiments } from 'enums';

const DASH_NOTE = '-';
interface SaleBannerContentProps {
  rootStore: RootStore;
}

const SaleBannerContentComp: React.FunctionComponent<
  SaleBannerContentProps
> = ({ rootStore }) => {
  const { discountPercent } = rootStore.appStore.appContext.saleParams;
  const bannerTitle = useSaleBannerTitle(rootStore.appStore);
  const { theme } = usePageModeContext();
  const {
    appStore: { experiments },
  } = rootStore;
  const { t } = useTranslation();

  return (
    <Text weight='bold' size='small'>
      {
        experiments[Experiments.EnableImmediateCouponsDeliverySpec] === 'true' ?
          t('premium-purchase-plan.header.sale_banner.biggest_sale_of_the_year')
          :
          <>
            <SaleBannerSubtitle />
            <span className={s.saleDash}>{DASH_NOTE}</span>
            <Trans
              i18nKey={bannerTitle}
              values={{ percent: discountPercent || '50' }}
            >
              <span className={classNames(s.saleDiscountColor, theme)}>
                SAVE {{ percent: discountPercent || '50' }}%
              </span>
              rest
            </Trans>
          </>
      }
    </Text>
  );
};

export const SaleBannerContent = withInjectedRootStore(SaleBannerContentComp);
